// extracted by mini-css-extract-plugin
export default {"hr":"CoHSl3Wpbbquggfz422v"};